import Vue from 'vue';
import VueI18n from 'vue-i18n';
const messages =  require('./locales')

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: 'ar',
    messages,
});

export default i18n;


// WEBPACK FOOTER //
// ./src/i18n.js